const t = "font-Inter font-normal text-12px leading-16px", e = "font-Inter font-normal text-11px leading-16px", l = "font-Inter font-medium text-10px leading-14px", n = "font-Inter font-semibold text-12px leading-16px", o = "font-Inter font-medium text-16px leading-22px", x = "font-Inter font-medium text-14px leading-18px", a = "font-Inter font-normal text-12px leading-16px";
export {
  t as labelRegularStyle,
  e as labelSmallRegularStyle,
  l as labelXSmallMediumStyle,
  n as labelXSmallSemiboldStyle,
  o as textMediumStyle,
  x as textSmallMediumStyle,
  a as textXSmallRegularStyle
};
